import { Typography } from 'antd'
import React, { useEffect, useState, useMemo } from 'react'
import dayjs from 'dayjs'

const { Text } = Typography

const DateTimeDisplay = React.memo(() => {
  const [currentDateTime, setCurrentDateTime] = useState(dayjs())

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(dayjs())
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const currentDate = useMemo(() => {
    return currentDateTime.format('MMM DD, YYYY')
  }, [currentDateTime])

  const currentTime = useMemo(() => {
    return currentDateTime.format('hh:mm A')
  }, [currentDateTime])

  return (
    <div style={{ textAlign: 'right' }}>
      <Text style={{ display: 'block', fontSize: 12, marginBottom: 2 }}>{currentDate}</Text>
      <Text strong style={{ fontSize: 15, color: '#1890ff' }}>
        {currentTime}
      </Text>
    </div>
  )
})

DateTimeDisplay.displayName = 'DateTimeDisplay'

export default DateTimeDisplay
